import React from 'react'

import { InfoPage } from "/react4xp/parts/infoPage/infoPage";

export default (props) => <InfoPage {...props} />
